module.exports = __webpack_public_path__ + "static/media/mypic.018d3a75.jpg";